import styled, { css } from 'styled-components';

import { Media } from '../../assets/Mixins.style';

import { Button as commonButton } from '../../assets/Common/Button.style';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 1105px;
  max-width: 90vw;
  min-height: 655px;
  overflow: auto;
  padding: 15px;

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }
`;

export const Box = styled.div`
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  flex-grow: 1;
  grid-gap: 20px;

  ${Media.md`
    flex-direction: column;
  `}
`;

export const ImageHolder = styled.div`
  position: relative;
  display: block;
  width: 100%;
  margin-right: 370px;
  border-radius: 5px;
  background: ${(props) => props.theme.background};

  ${Media.md`
    height: 50vh;
    margin-right: initial;
  `}
`;

export const Arrow = styled.span`
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  color: ${(props) => props.theme.color};
  text-shadow: 0px 3px 6px ${(props) => props.theme.shadow};
  cursor: pointer;
  z-index: +2;

  ${(props) =>
    props.left &&
    css`
      left: 0;
    `}

  ${(props) =>
    props.right &&
    css`
      right: 0;
    `}
`;

export const ArrowIcon = styled.i`
  color inherit;
  font-size: 72px;
`;

export const Image = styled.img`
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: +1;
`;

export const Video = styled.video`
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: +1;
`;

export const Placeholder = styled.i`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 128px;
`;

export const ContentHolder = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  display: block;
  width: 350px;
  flex-shrink: 0;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 3px;
    height: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
    border-radius: 3px;
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }

  ${Media.md`
    position: relative;
    top: initial;
    bottom: initial;
    right: initial;
    width: initial;
  `}
`;

export const Header = styled.div`
  position: sticky;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 0;
  width: 100%;
  padding: 4px 0 12px;
  border-bottom: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
`;

export const Title = styled.h2`
  display: inline-block;
  color: ${(props) => props.theme.color};
  font-size: 19px;
  font-weight: 500;
  text-align: left;
  cursor: default;
`;

export const Content = styled.div`
  display: block;
  width: 100%;
  padding: 15px 0;
`;

export const Details = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: auto;
  margin: -5px -5px 0;
`;

export const Subtitle = styled.h3`
  display: block;
  width: 100%;
  padding: 0 0 5px;
  color: ${(props) => props.theme.color};
  font-size: 16px;
  font-weight: 400;
  text-align: left;
  cursor: default;
`;

export const Detail = styled.span`
  display: inline-block;
  width: auto;
  margin: 5px;
  padding: 8px 11px;
  border-radius: 5px;
  background: ${(props) => props.theme.background};
  color: ${(props) => props.theme.color};
  font-size: 17px;
  font-weight: 700;
  line-height: 1;
  text-align: left;
  word-break: break-word;
  user-select: text;
  cursor: default;
`;

export const DetailLabel = styled.span`
  display: inline;
  width: auto;
  color: ${(props) => props.theme.color};
  user-select: text;
`;

export const Footer = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  flex-shrink: 0;
  padding: 15px 0 0 0;
  margin-top: 15px;

  &:after {
    position: absolute;
    width: auto;
    height: 1px;
    background: ${(props) => props.theme.backgroundLine};
    right: 0;
    left: 0;
    top: 0;
    z-index: +1;
    content: '';
  }

  ${Media.md`
    justify-content: center;
  `}
`;

export const OptionButton = styled.button`
  ${commonButton}
  margin: 0 0 0 10px;

  &:first-of-type {
    margin-left: 0;
  }

  ${Media.md`
    margin: 5px;
  `}
`;

export const OptionButtonIcon = styled.i`
  margin-left: -5px;
  margin-right: 5px;
`;

export const Grow = styled.div`
  flex-grow: 1;
`;
